<template>
  <!-- Modal de confirmation de renvoi -->
  <div class="modal fade" id="resendModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header border-0"></div>

          <div class="modal-body mt-n5 pb-5">
            <div class="message-details w-70 mx-auto text-center">
              <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
              <h5>{{ $t("messages.confirm_resend_campaign") }}</h5>
            </div>
            <div class="row mt-4">
              <div class="col-md-10 mx-auto">
                <div class="detail-card p-3" style="font-size: 1rem">
                  <span v-if="selectedMessage.criteria">
                    <span v-if="selectedMessage.criteria.target">
                      <strong>{{ $t("messages.target") }}:</strong>
                      {{ selectedMessage.criteria.target }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-md-10 mx-auto">
                <div class="detail-card">
                  <h6 class="detail-title">
                    <i class="fas fa-comment-alt me-2"></i>{{ $t("messages.french_message") }}
                  </h6>
                  <div class="message-content" v-html="selectedMessage.body"></div>
                </div>
              </div>

              <div v-if="selectedMessage.media" class="attachment-section mt-4 text-start mx-auto col-md-10">
                <h6 class="detail-title">
                  <i class="fas fa-paperclip me-2"></i>{{ $t("messages.attachment") }}
                </h6>
                <div class="images zoomable-image"></div>
                <img
                  v-if="isImage(selectedMessage.media)"
                  :src="selectedMessage.media"
                  class="media-preview w-50"
                  :alt="$t('messages.attached_image')"
                />
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 pb-5 mb-1">
            <argon-button
              type="button"
              class="btn bg-transparent"
              data-bs-dismiss="modal"
              style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);"
            >
              {{ $t("button.cancel") }}
            </argon-button>
            <argon-button
              :loading="loading"
              :active="buttonActive || showConfirmation"
              :clickEvent="button"
              type="button"
              class="mt-1"
              style="width: 150px; height: 50px; padding-top: 15px; margin-right: 85px;"
              @click="confirmResend"
            >
              {{ $t("button.confirm") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="top">
      <h6>{{ $t("messages.sent_messages") }}</h6>
    </div>
    <div>
      <div v-if="isLoading" class="text-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ $t("messages.loading") }}</span>
        </div>
      </div>

      <table v-else-if="campaigns.length" class="table table-striped table-hover" style="border: 1px solid rgba(255, 255, 255, 0.4)">
        <thead>
          <tr>
            <th class="w-5">#</th>
            <th class="border">{{ $t("messages.message") }}</th>
            <th class="border w-25">Destinataire</th>
            <th class="border d-none w-10">{{ $t("messages.sent") }}</th>
            <th class="border w-20 text-end">{{ $t("messages.date") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(message, index) in paginatedMessages" :key="message.id" class="message-row">
            <td class="ps-4 border">
              {{ index + 1 + (currentPage - 1) * itemsPerPage }}
            </td>
            <td class="ps-4 border">
              {{ stripHtmlAndLimitWords(message.body, 5) }}
            </td>
            <td class="ps-4 border">
              <div class="criteria-display">
                {{ formatCriteria(message.criteria) }}
              </div>
            </td>
            <td class="text-end position-relative pe-4">
              <div class="content-class last_td">
                {{ formatDateTime(message.created_on) }}
              </div>
              <span class="action-icons border-0">
                <i
                  :title="$t('messages.view_campaign_details')"
                  class="fas fa-eye"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal34"
                  @click="viewDetails(message)"
                ></i>
                <i
                  :title="$t('messages.resend_campaign')"
                  data-bs-toggle="modal"
                  data-bs-target="#resendModal"
                  class="fas fa-history"
                  @click="resendCampaign(message)"
                ></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="text-center my-5">
        <img class="image" src="@/assets/img/message.png" alt="no_message"/>
        <h5 class="text-muted mt-n5">{{ $t("messages.no_messages_found") }}</h5>
      </div>
      
      <!-- Pagination -->
      <nav aria-label="Pagination" class="text-start" v-if="campaigns.length > 0">
        <ul class="pagination justify-content-start mt-5">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">
              <i class="fas fa-chevron-left"></i>
            </button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">
              <i class="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="exampleModal34" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title fw-bold ps-4" id="exampleModalLabel">
              <i class="fas fa-envelope-open-text me-2"></i>
              {{ $t("messages.message_details") }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body mt-n3">
            <div class="message-details">
              <div class="row">
                <div class="row mb-3">
                  <div class="col-md-12">
                      <div class="detail-card p-3" style="font-size: 1rem">
                      <strong>{{ $t('messages.filter_criteria') }}</strong>
                      <div class="mt-2">{{ formatCriteria(selectedMessage.criteria) }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mt-n3">
                  <div class="detail-card">
                    <h6 class="detail-title">
                      {{ $t("messages.french_message") }}
                    </h6>
                    <div class="message-content" v-html="selectedMessage.body"></div>
                  </div>
                </div>
              </div>

              <div v-if="selectedMessage.media" class="attachment-section mt-4 text-start">
                <h6 class="detail-title">
                  <i class="fas fa-paperclip me-2"></i>{{ $t("messages.attachment") }}
                </h6>

                <img
                  v-if="isImage(selectedMessage.media)"
                  :src="selectedMessage.media"
                  class="media-preview"
                  :alt="$t('messages.attached_image')"
                />

                <video v-if="isVideo(selectedMessage.media)" class="media-preview" controls>
                  <source :src="selectedMessage.media" :type="getVideoType(selectedMessage.media)" />
                </video>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 pb-5 mb-1">
            <button
              type="button"
              class="btn me-3 bg-transparent"
              data-bs-dismiss="modal"
              style="height: 50px; border: 1px solid rgba(255, 255, 255, 0.4); width: 150px; color: #fff; border-radius: 10px;"
            >
              {{ $t("button.close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sendmessage} from "@/utils/services";
import ArgonButton from "@/components/ArgonButton";
import {toast} from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "MessagesTable",
  props: {
    campaigns: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ArgonButton,
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      selectedMessage: {},
      localLoading: false,
      isSubmitting: false,
      buttonActive: false,
      showConfirmation: false,
      isLoading: false,
      fr_title: "",
      fr_body: "",
      loading: false,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.campaigns.length / this.itemsPerPage);
    },
    paginatedMessages() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return [...this.campaigns].reverse().slice(start, end);
    },
    hasClassInfo() {
      return (
        this.selectedMessage?.criteria?.grade_code ||
        this.selectedMessage?.criteria?.number
      );
    },
  },
  methods: {
    formatCriteria(criteria) {
      if (!criteria || Object.keys(criteria).length === 0) {
        return this.$t('messages.automatic_message');
      }

      const parts = [];

      if (criteria.target) {
        parts.push(` ${criteria.target}`);
      }

      if (criteria.grade) {
        if (criteria.grade === "all_grades") {
          parts.push(this.$t('messages.class_all'));
        } else {
          parts.push(this.$t('messages.class_label', { grade: criteria.grade }));
        }
      }

      if (criteria.classroom_number) {
        parts.push(`Salle: ${criteria.classroom_number}`);
      }

      return parts.length > 0 ? parts.join(" | ") : this.$t('messages.no_criteria');
    },

    isImage(url) {
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
    },
    
    isVideo(url) {
      return /\.(mp4|webm|ogg)$/i.test(url);
    },
    
    getVideoType(url) {
      const ext = url.split(".").pop().toLowerCase();
      return `video/${ext}`;
    },
    
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    
    viewDetails(message) {
      this.selectedMessage = message;
    },

    resendCampaign(message) {
      this.selectedMessage = message;
    },

    stripHtmlAndLimitWords(html, wordCount) {
      if (!html) return "";
      const plainText = html.replace(/<[^>]*>/g, "");
      const words = plainText.split(/\s+/);
      const limitedWords = words.slice(0, wordCount);
      return limitedWords.join(" ") + (words.length > wordCount ? "..." : "");
    },

    async confirmResend() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.buttonActive = true;
      try {
        if (!this.selectedMessage?.body) {
          toast.error(this.$t("messages.errors.missing_message_data"));
          return;
        }

        const messageData = {
          target: this.selectedMessage.criteria.target,
          grade: this.selectedMessage.criteria.grade,
          classroom_number: this.selectedMessage.criteria.classroom_number,
          body: this.selectedMessage.body,
          media_url: this.selectedMessage.media,
        };

        await sendmessage(messageData);
        if (!this.showConfirmation) {
          this.showConfirmation = true;
          toast.success(this.$t("messages.success.message_sent"), {
            autoClose: 3000,
          });
        }

        this.cleanupModal();

        setTimeout(() => {
          window.location.reload();
        }, 4000);
      } catch (error) {
        console.error("Erreur lors du renvoi de la campagne:", error);
        toast.error(this.$t("messages.errors.send_failed"), {
          autoClose: 3000,
        });
      } finally {
        this.loading = false;
        this.buttonActive = false;
      }
    },

    cleanupModal() {
      document.body.classList.remove("modal-open");
      const modalBackdrops = document.getElementsByClassName("modal-backdrop");
      for (const backdrop of modalBackdrops) {
        backdrop.parentNode.removeChild(backdrop);
      }
    },

    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
  },
};
</script>

<style scoped>
/* .criteria-display {
  font-size: 0.9rem;
  line-height: 1.5;
  color: #555;
} */

.modal-content {
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.modal-header {
  border-radius: 15px 15px 0 0;
  padding: 1.5rem;
}

.message-details {
  padding: 20px;
}

.detail-card {
  border-radius: 10px;
  padding: 15px;
  height: 100%;
}

.detail-title {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 1rem;
}

.message-content {
  padding: 10px;
  border-radius: 8px;
  min-height: 100px;
  border: 1px solid rgba(250, 250, 250, 0.1);
}

.attachment-section {
  border-radius: 10px;
  padding: 20px;
}

.modal-footer {
  border-top: none;
  padding: 1.5rem;
}

.message-row {
  position: relative;
  cursor: pointer;
}

.action-icons {
  display: none;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.message-row:hover .action-icons {
  display: flex;
  gap: 15px;
}

.message-row:hover .last_td {
  filter: blur(4px);
}

.action-icons i {
  color: green;
  cursor: pointer;
  font-size: 18px;
}

.action-icons i:hover {
  color: darkgreen;
}

.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.table {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
}

.media-preview {
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  margin: 10px 0;
  object-fit: contain;
}

.position-relative {
  position: relative;
  width: 100px;
}

.zoomable-image {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: zoom-in;
}

.zoomable-image:hover {
  transform: scale(1.1);
  z-index: 2;
}
</style>